import { useQuery } from "react-query";
import { getSettings } from "contexts/settings/lib/data";

export const useGetSettings = (authenticated) => {
    return useQuery({
        queryKey: ["settings"],
        queryFn: () => getSettings(),
        enabled: !!authenticated,
    });
};
